import React from 'react';
import { useAppOrigin } from '../hooks/useValidate';
import { Col } from 'react-bootstrap';
import { Homepage } from '../components/user/Homepage';
import { Menu } from '../components/shared/Menu';
import { useSelector } from 'react-redux';
import { Loading } from '../components/shared/Loading';
import { slimAdvancedTier } from '../helpers/menu';
import { useMenu } from '../hooks/useHelpMenu';
import { slimTier } from '../constants/form';

/**
 * User home page and level menu page
 * @returns {JSX}
 */
const HomepagePage = () => {
  const { autoLoginURL } = useSelector(state => state.base);
  useAppOrigin();
  const [tiers] = React.useState(slimAdvancedTier() || [])
  const { onClick } = useMenu()
  
  React.useEffect(() => {
    const slimAdvanced = tiers?.find(tier => tier?.unique_name === slimTier)
    setTimeout(() => {
      if (slimAdvanced && autoLoginURL?.active) {
        onClick(slimAdvanced)
      }
    }, 0)
  }, [tiers])

  return (
    <>
        <Col className={`p-0 ${autoLoginURL?.active ? ' d-none' : ''} `} xs={12} md={6} xl={8}>
          <Homepage />
        </Col>
        <Col className={`p-0 ${autoLoginURL?.active ? ' d-none' : ''} `} xs={12} md={6} xl={4}>
          <Menu />
        </Col>
      { (autoLoginURL?.active) && <Loading />}
    </>
  );
};

export default HomepagePage;